export default __webpack_public_path__ + "static/media/service-reminders-mobile-preview.f4637f4f.png";